import ModalFolderNameForm from "./ModalFolderNameForm";
import {
  BUTTON_SAVE,
  GALLERY_FOLDERS_RENAME_ERROR,
  GALLERY_FOLDERS_RENAME_SUCCESS,
  GALLERY_FOLDERS_RENAME_TITLE,
} from "../../i18n/keysTranslations";

const ModalRenameContentFolder = ({
  modalOpen = false,
  folders = [],
  folder = null,
  isLoading = false,
  onCloseModal = () => {},
  onCallbackRename = async () => ({ ok: false }),
}) => {
  return (
    <ModalFolderNameForm
      modalOpen={modalOpen}
      folders={folders}
      parentFolderID={folder?.parentFolderID}
      excludeFolderID={folder?.id}
      initialName={folder?.name || ""}
      title={GALLERY_FOLDERS_RENAME_TITLE}
      ariaLabel={GALLERY_FOLDERS_RENAME_TITLE}
      primaryButtonText={BUTTON_SAVE}
      errorText={GALLERY_FOLDERS_RENAME_ERROR}
      successText={GALLERY_FOLDERS_RENAME_SUCCESS}
      isLoading={isLoading}
      onCloseModal={onCloseModal}
      onSubmitName={({ name }) =>
        onCallbackRename({
          folderID: folder?.id,
          name,
        })
      }
    />
  );
};

export default ModalRenameContentFolder;
